// extracted by mini-css-extract-plugin
export default {"archive-link":"CrDiffArchive_archive-link__LdoGI"};